import cn from "classnames";
import Avatar from "components/shared/avatar";
import Loader from "components/shared/loader";
import { OnlineStatus } from "components/shared/user";
import ScrollPositionContext from "contexts/scrollPosition";
import { bidChatDomainTypesEnum, chatTypesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import { ymEvent } from "helpers/system";
import policy from "policies";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { getBidChatInfo } from "sources/books/bids";
import { addChatToFavorites, getParticipant, removeChatFromFavorites } from "sources/messages";
import { block } from "sources/organization";
import Chat from "./body";
import Footer from "./footer";
import Participants from "./participants";

const initialState = {
    isLoading: true,
    openedDropd: false,
    rate: {},
    info: {},
    system: false,
    onlyMyMessages: false,
    organization: {
        imageUrl: "",
        name: "Organization",
        id: 0,
    },
};

export default class ChatLayout extends Component {
    static contextType = ScrollPositionContext;

    state = {
        ...initialState,
    };

    componentDidMount() {
        this.dataRequest = this.getData();
        this.context.setPrevItemId?.(Number(this.props.chatId));
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.chatId !== nextProps.chatId || nextProps.shouldUpdateChat) {
            this.dataRequest = this.getData(nextProps);
            nextProps.changeShouldUpdateChat(false);
        }
    }

    componentWillUnmount() {
        this.dataRequest = null;
    }

    getData = (props) => {
        const { chatId } = props || this.props;
        this.setState(initialState);
        getParticipant(chatId)
            .then((res) => this.handleParticipant(res))
            .then(() => getBidChatInfo(chatId))
            .then((info) => {
                const system = info.type === chatTypesEnum.System;
                this.setState({ rate: {}, system, info, isLoading: false });
            });
    };

    updateChatInfo = () => getBidChatInfo(this.props.chatId).then((info) => this.setState({ info }));

    handleParticipant = (res) => {
        if (res) {
            const organization = res.find((item) => item.id !== this.props.profile.organizationId);
            return this.setState({ organization });
        }
        return null;
    };

    getCard = () => {
        const { modal } = this.props;
        const { organization } = this.state;
        return modal({ name: "organization", title: "Карта партнера", id: organization.id, data: organization });
    };

    closeAccess = () => {
        const { modal, back } = this.props;
        const { name, id } = this.state.organization;
        return modal({
            name: "confirm",
            title: "Блокирование организации",
            text: `Вы уверены, что хотите заблокировать "${name}"?`,
            callback: back,
            action: () => block({ id }),
        });
    };

    calcId = () => {
        const { id } = this.state.organization;
        return id;
    };

    updateAll = () => {
        const { mergeChatsParams, mergeBidsParams, history } = this.props;
        mergeChatsParams({});
        mergeBidsParams({});
        history.push(paths.root);
    };

    updateAllForTruckingOrganizationUser = () => {
        const { mergeChatsParams, mergeBidsParams, changeShouldUpdateBid } = this.props;
        mergeChatsParams({});
        mergeBidsParams({});
        this.getData();
        if (changeShouldUpdateBid) {
            changeShouldUpdateBid(true);
        }
    };

    renderDropd = () => {
        const { openedDropd } = this.state;
        const actions = [
            { text: "Карта партнера", action: this.getCard },
            { text: "Закрыть доступ", action: this.closeAccess },
        ];

        return (
            openedDropd && (
                <ul className="c-dropd__list no-bullet">
                    {actions.map((item) => (
                        <li key={item.text} className="c-dropd__list-item" onClick={item.action}>
                            {item.text}
                        </li>
                    ))}
                </ul>
            )
        );
    };

    openDropd = () => {
        this.setState({ openedDropd: true });
        setTimeout(() => document.addEventListener("click", this.closeDropd), 0);
    };

    closeDropd = () => {
        this.setState({ openedDropd: false });
        document.removeEventListener("click", this.closeDropd);
    };

    driverInfo = (driver) => {
        const { fullName } = driver;
        return (
            <div>
                <small className="text-muted">{fullName}</small>
                <OnlineStatus {...driver} organizationTimezone={this.props.organizationTimezone} />
            </div>
        );
    };

    toggleFavorite = (e) => {
        e.stopPropagation();
        const { info } = this.state;
        const { chatId } = this.props;
        if (this.state.isLoadingHeader) {
            return;
        }

        this.setState({ isLoadingHeader: true, info: { ...info, isFavorite: !info.isFavorite } });
        (info.isFavorite ? removeChatFromFavorites({ chatId }) : addChatToFavorites({ chatId })).then((res) =>
            this.setState({
                isLoadingHeader: false,
                ...(res ? {} : { info: { ...info, isFavorite: info.isFavorite } }),
            }),
        );
    };

    setOnlyMyMessages = (onlyMyMessages) => this.setState({ onlyMyMessages });

    render() {
        const { system, organization, info, onlyMyMessages } = this.state;
        const { name, imageUrl } = organization || {};
        const { chatId, profile, token, back, modal, mergeChatsParams, roles } = this.props;
        let isBidRate = false;
        let isChatWithDriver = false;
        let driver;
        if (!!info && !!info.bidChat) {
            isBidRate = info.bidChat.type === bidChatDomainTypesEnum.Rate;
            isChatWithDriver = info.bidChat.type === bidChatDomainTypesEnum.Secondary;
            driver = isChatWithDriver ? info.users.find((user) => user.isDriver) : undefined;
        }
        const avatarCname = cn("chat-layout__head-avatar", {
            "chat-layout__head-avatar--system": system || isBidRate === false,
        });
        let chatTitle = name || "";
        const chatDescription = info.description ? ` - ${info.description}` : "";

        if (isBidRate) {
            chatTitle = (
                <span>
                    Заявка{" "}
                    <Link to={`${paths.bidShow("rate", info.bidChat.bidId)}?from=chat&chatId=${chatId}`}>
                        №{info.bidChat.bidId}
                    </Link>{" "}
                    - {name}
                </span>
            );
        } else if (info.bidChat) {
            chatTitle = (
                <span>
                    {!chatDescription && !!info.bidChat.carNumber && info.bidChat.carNumber + ", "}Заявка{" "}
                    <Link to={`${paths.bidShow("bid", info.bidChat.bidId)}?from=chat&chatId=${chatId}`}>
                        №{info.bidChat.bidId}
                    </Link>
                    {chatDescription}
                    {isChatWithDriver && driver && (
                        <>
                            <br />
                            {this.driverInfo(driver)}
                        </>
                    )}
                </span>
            );
        }

        const props = {
            chatId,
            info,
            profile,
            token,
            updateChats: mergeChatsParams,
            modal: this.props.modal,
            onlyMyMessages,
            showOnlyMyMessages: true,
            onOnlyMyMessagesChange: this.setOnlyMyMessages,
        };

        return this.state.isLoading ? (
            <Loader prefix="absolute-center" />
        ) : (
            <div className="page-book__show chat-layout">
                <div className="chat-layout__head">
                    <Avatar cname={avatarCname} imageUrl={system ? null : imageUrl} />
                    <div
                        className={cn("chat-layout__head-name", {
                            "loading loading--small": this.state.isLoadingHeader,
                        })}
                    >
                        <div className="d-flex w-100">
                            <div className="flex-grow-1">
                                <i
                                    className={cn("chat-layout__favorite-icon icon-uEABA-star-solid", {
                                        "chat-layout__favorite-icon--selected": info.isFavorite,
                                    })}
                                    onClick={this.toggleFavorite}
                                />

                                {system ? "Система" : chatTitle}
                            </div>
                            <div>
                                <div className="clearfix pb-2">
                                    <Participants
                                        info={info}
                                        users={info?.users ?? []}
                                        type={info?.type}
                                        bidId={info?.bidChat?.bidId}
                                        isParticipant={info?.isParticipant}
                                        chatId={chatId}
                                        modal={modal}
                                        back={back}
                                        profile={profile}
                                        updateChatInfo={this.updateChatInfo}
                                    />
                                </div>
                                <div className="d-flex flex-column">
                                    <Link
                                        to={`${paths.profileAccount}?tab=notification-settings`}
                                        className="font-size-12 nowrap-text align-self-end"
                                        onClick={() => ymEvent("NotificationsSettingsClicked")}
                                    >
                                        <i className="icon-uEA0C-gear inline-icon pr-1" />
                                        Настройки уведомлений
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="chat-layout__close close close--md" onClick={back} />
                    {system || isBidRate === false ? null : (
                        <div className="chat-layout__dropdown c-dropd">
                            <div className="c-dropd__btn" onClick={this.openDropd} />
                            {this.renderDropd()}
                        </div>
                    )}
                </div>
                <div className="chat-layout__body">
                    <Chat {...props}>
                        {!(system || policy("user", { user: { roles } }).isOnlyViewer()) && (
                            <Footer chatId={chatId} modal={modal} info={this.state.info} theme={this.props.theme} />
                        )}
                    </Chat>
                </div>
            </div>
        );
    }
}
